'use client'

import { memo, useMemo } from 'react'
import { Chip } from '@heroui/react'
import { Command } from '@heroui-pro/react'
import { Search } from 'lucide-react'
import { APP_NAME } from '../lib/branding'
import { commandItems } from './navigation'

interface CommandPaletteProps {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  routeTitle: string
  onNavigate: (route: string) => void
}

export const CommandPalette = memo(function CommandPalette({ isOpen, onOpenChange, routeTitle, onNavigate }: CommandPaletteProps): React.ReactElement {
  const commandRouteById = useMemo(
    () => new Map(commandItems.map((item) => [item.id, item.to])),
    [],
  )

  return (
    <Command>
      <Command.Backdrop
        isOpen={isOpen}
        onOpenChange={onOpenChange}
      >
        <Command.Container size="md">
          <Command.Dialog>
            <Command.Header className="flex items-center gap-2 px-3 pb-0 pt-3">
              <Chip color="accent" size="sm" variant="soft">
                {APP_NAME}
              </Chip>
              <Chip size="sm" variant="soft">
                {routeTitle}
              </Chip>
            </Command.Header>
            <Command.InputGroup>
              <Command.InputGroup.Prefix>
                <Search className="size-4" />
              </Command.InputGroup.Prefix>
              <Command.InputGroup.Input placeholder="Search workspace" />
              <Command.InputGroup.ClearButton />
            </Command.InputGroup>
            <Command.List
              renderEmptyState={() => (
                <div className="flex h-16 items-center justify-center text-sm text-muted">
                  No results found.
                </div>
              )}
              onAction={(key) => {
                const route = commandRouteById.get(String(key))
                if (route) onNavigate(route)
              }}
            >
              <Command.Group heading="Navigate">
                {commandItems.map((item) => {
                  const Icon = item.icon
                  return (
                    <Command.Item key={item.id} id={item.id} textValue={item.label}>
                      <Icon className="size-4" />
                      <span>{item.label}</span>
                    </Command.Item>
                  )
                })}
              </Command.Group>
            </Command.List>
          </Command.Dialog>
        </Command.Container>
      </Command.Backdrop>
    </Command>
  )
})
